export const accountsRoute = {
  path: ":menu/accounts",
  component: () => import("@/views/accounts/list/index.vue"),
};
